import { useTranslation } from 'react-i18next';
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

const PublishCompletedModal = ({
  publishComplete,
  cardDesignPublishModalComplete,
}) => {
  const { t } = useTranslation('card_designs', 'buttons');

  return (
    <Modal isOpen={cardDesignPublishModalComplete} centered={true}>
      <ModalHeader>{t('cdsgn_publish_design_label')}</ModalHeader>
      <ModalBody>
        <Label>{t('cdsgn_design_pulish_complete_one')}</Label>
        <Label>{t('cdsgn_design_pulish_complete_two')}</Label>
      </ModalBody>
      <ModalFooter>
        <Button color='primary' onClick={() => publishComplete()}>
          {t('buttons:btn_ok')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PublishCompletedModal;
